// peak navbar
import React from "react";
import { Link } from "react-router-dom";
import { loginWithGoogle, logout } from "../assets/Logic/auth";
import type  { User } from "firebase/auth";
import logo from "../assets/Images/logo.png";


interface NavbarProps {
  user: User | null;
}


const Navbar: React.FC<NavbarProps> = ({ user }) => {
  return (
    <nav className="navbar">
      {/* left */}
      <div className="nav-left">
        <img src={logo} alt="BoredGames Logo" className="logo-img" />
        <h1 className="logo-text">BoredGames</h1>
      </div>

      {/* middle */}
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/games">Games</Link></li>
        <li><Link to="/about">About</Link></li>
        {user && <li><Link to="/profile">Profile</Link></li>}
      </ul>

      {/* right */}
      <div className="nav-auth">
        {user ? (
          <>
            <div className="user-info">
              <img
                src={user.photoURL || "./src/assets/Images/user-icon.png"}
                alt="Profile"
                className="profile-pic"
              />
              <span className="username">{user?.displayName || "User"}</span>
            </div>
            <button onClick={logout} className="btn-logout">Logout</button>
          </>
        ) : (
          <button onClick={loginWithGoogle} className="btn-login">
            Login with Google
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
